import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n'

console.log('=== ZO BULL v6.2.0 STARTING ===')

// Hide loading screen with fade transition
const hideLoader = () => {
  const loader = document.getElementById('initial-loader')
  if (loader) {
    loader.classList.add('hidden')
    setTimeout(() => {
      loader.style.display = 'none'
      console.log('[main.tsx] Loading screen hidden')
    }, 300) // Match CSS transition duration
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  document.body.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;color:#fff;">Error: Root element not found!</div>'
  throw new Error('Root element not found!')
}

console.log('[main.tsx] Creating React root...')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

console.log('[main.tsx] React root created')
hideLoader()
